module.exports = __webpack_public_path__ + "img/qiche.9d099bbb.png";